import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";

const Confirmation = (props) => {
  const { body, handleYes, title, className, show, ...modalProps } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      setIsSubmitting(false);
    }
  }, [show]);

  const handleConfirm = () => {
    setIsSubmitting(true);
    if (handleYes) {
      handleYes();
    }
  };

  return (
    <Modal
      {...modalProps}
      show={show}
      size="md"
      className="modal-container"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="bg-transparent">
        <Modal.Title className="text-center fw-bold fs-3 mb-1 ">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-gray-700">
          {body ? body : "Do you wish to duplicate this item?"}
        </p>
      </Modal.Body>
      <Modal.Footer className=" d-flex justify-content-center bg-transparent px-3 pt-3">
        <button onClick={props.onHide} style={{
          padding: '8px 20px', fontSize: '13px', fontWeight: '600',
          color: '#374151', backgroundColor: '#f3f4f6',
          border: '1.5px solid #e5e7eb', borderRadius: '8px',
          cursor: 'pointer', transition: 'background-color 0.15s ease',
        }}>
          No
        </button>
        <button
          onClick={handleConfirm}
          style={{
            padding: '8px 22px', fontSize: '13px', fontWeight: '600',
            color: '#fff', backgroundColor: '#1a7d3e', border: 'none',
            borderRadius: '8px', cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(26,125,62,0.3)',
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            transition: 'background-color 0.15s ease',
          }}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Yes"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Confirmation;
